import React, { useState } from "react";
import { injectReducer } from "../../store/index.js";
import saudaReducer from "./store";
import Card from "antd/es/card/Card.js";
import SaudaTable from "./components/saudaTable.js";
import { DatePicker } from "antd";
import AllSaudaList from "./components/allSaudaList.js";

injectReducer("sauda", saudaReducer);

const SaudaList = () => {
  return (
    <Card className="page-content">
      <div className="lg:flex items-center justify-between mb-4">
        <h3 className="mb-4 lg:mb-0 text-3xl">All Sauda List</h3>
      </div>
      <AllSaudaList />
    </Card>
  );
};
export default SaudaList;
